import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Briefcase, FileUp, Building2, Phone } from "lucide-react";

const items = [
  { label: "Home", to: "/", icon: Home },
  { label: "Jobs", to: "/jobs", icon: Briefcase },
  { label: "Apply", to: "/submit-resume", icon: FileUp },
  { label: "Hire", to: "/for-employers", icon: Building2 },
  { label: "Contact", to: "/contact", icon: Phone },
];

export default function MobileBottomNav() {
  const loc = useLocation();
  return (
    <nav data-testid="mobile-bottom-nav" className="md:hidden fixed bottom-0 inset-x-0 z-40 glass-strong border-t border-white/10">
      <div className="grid grid-cols-5">
        {items.map(({ label, to, icon: Icon }) => {
          const active = loc.pathname === to;
          return (
            <Link
              key={to}
              to={to}
              data-testid={`bottomnav-${label.toLowerCase()}`}
              className={`flex flex-col items-center gap-1 py-2.5 text-[11px] font-medium transition-colors ${active ? "text-brand-emerald" : "text-slate-400"}`}
            >
              <Icon size={20} />
              {label}
              {active && <span className="absolute top-0 h-0.5 w-8 rounded-full bg-brand-emerald" />}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
